import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { searchGroupsByName } from 'api/operations/groupService';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { GroupSearchReturnType } from 'types/groupService';

interface GroupFormFields extends DefaultFormFields {
  name: FormControl<string>;
}

export class SearchGroupsModalStore {
  rootStore: RootStore;
  groupForm: FormController<GroupFormFields>;
  searchedGroupsList: GroupSearchReturnType[] = [];
  public loading = false;

  public setLoading(status: boolean): void {
    this.loading = status;
  }

  public async requestGroupSearchByName(fullAgencyView: boolean): Promise<void> {
    const res = await searchGroupsByName(this.groupForm.fields.name.value, 10, fullAgencyView);
    runInAction(() => {
      this.searchedGroupsList = res;
    });
  }

  public resetSearchedGroupsList(): void {
    this.searchedGroupsList = [];
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.groupForm = new FormController({
      name: new FormControl<string>(''),
    });

    makeObservable(this, {
      groupForm: observable,
      loading: observable,
      searchedGroupsList: observable,
      setLoading: action.bound,
      requestGroupSearchByName: action.bound,
      resetSearchedGroupsList: action.bound,
    });
  }
}
